import { gql } from '@apollo/client';

export const GET_SECTORS_QUERY = gql`
  query getSectorsQuery(
    $master_list: Boolean
    $group_id: String
    $company_id: String
    $id: String
  ) {
    sectors(master_list: $master_list, group_id: $group_id, company_id: $company_id, id: $id) {
      id
      deleted
      name
      master_list_sector {
        id
      }
    }
  }
`;
